(function () {
  function init() {
    if (!('IntersectionObserver' in window)) return;

    var sections = document.querySelectorAll('.bestsellers-custom');
    if (!sections.length) return;

    // On tablet/mobile the layout reorders: numbering sits top-right (with the
    // heading, revealed by trigger A) and the "view all" button moves to the
    // bottom (revealed by trigger B). On desktop trigger B = numbering + arrows.
    var isMobile = window.matchMedia('(max-width: 1023.98px)').matches;

    sections.forEach(function (section) {
      // Mark section so the hidden initial states apply (only when JS runs)
      section.classList.add('bsc-anim');

      // Trigger A — heading (+ numbering on mobile) and product cards (staggered)
      var head = section.querySelector('.bestsellers-custom__header') || section;
      var obsHead = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              section.classList.add('bsc-reveal-head');
              obsHead.disconnect();
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
      );
      obsHead.observe(head);

      // Trigger B — desktop: numbering + arrows; mobile: bottom "view all" button
      var ctrlTarget = isMobile
        ? section.querySelector('.bestsellers-custom__btn-mobile-wrap')
        : section.querySelector('.fpt-controls');
      if (ctrlTarget) {
        var obsCtrl = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                section.classList.add('bsc-reveal-ctrl');
                obsCtrl.disconnect();
              }
            });
          },
          { threshold: 0, rootMargin: '0px 0px -8% 0px' }
        );
        obsCtrl.observe(ctrlTarget);
      } else {
        section.classList.add('bsc-reveal-ctrl');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
